import { createServerFn } from '@tanstack/react-start'

import { loginInputSchema } from '@/features/Auth/Login/validation.ts'
import { loginService } from '@/server/Auth/Login/login.service.ts'

export const loginHandler = createServerFn({ method: 'POST' })
    .validator(function (data: unknown) {
        return loginInputSchema.parse(data)
    })
    .handler(async function ({ data }) {
        return loginService(data)
    })
